import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DemoMaterialModule } from "../demo-material-module";
import { VariedadEditComponent } from "./variedad/variedad-edit/variedad-edit.component";
import { EspecieListComponent } from "./especie/especie-list/especie-list.component";
import { EspecieEditComponent } from "./especie/especie-edit/especie-edit.component";
import { DescriptorListComponent } from "./descriptor/descriptor-list/descriptor-list.component";
import { DescriptorEditComponent } from "./descriptor/descriptor-edit/descriptor-edit.component";
import { DescriptorDataListComponent } from "./descriptor-data/descriptor-data-list/descriptor-data-list.component";
import { DescriptorDataEditComponent } from "./descriptor-data/descriptor-data-edit/descriptor-data-edit.component";
import { DescriptorCategoriaListComponent } from "./descriptor-categoria/descriptor-categoria-list/descriptor-categoria-list.component";
import { DescriptorCategoriaEditComponent } from "./descriptor-categoria/descriptor-categoria-edit/descriptor-categoria-edit.component";
import { VariedadItemComponent } from "./variedad/variedad-item/variedad-item.component";
import { DescriptorItemComponent } from "./descriptor/descriptor-item/descriptor-item.component";
import { DescriptorCategoriaItemComponent } from "./descriptor-categoria/descriptor-categoria-item/descriptor-categoria-item.component";
import { DescriptorDataItemComponent } from "./descriptor-data/descriptor-data-item/descriptor-data-item.component";
import { EspecieItemComponent } from "./especie/especie-item/especie-item.component";
import { InfoItemComponent } from "./info/info-item/info-item.component";
import { RouterModule } from "@angular/router";
import { AuthSigInComponent } from "./auth/auth-sig-in/auth-sig-in.component";
import { AuthSigUpComponent } from "./auth/auth-sig-up/auth-sig-up.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { AuthInterceptor } from "./auth/auth-interceptor";
import { DetailViewComponent } from "./widget/detail-view/detail-view.component";
import {
  GalleryComponent,
  GalleryZoom,
} from "./widget/gallery/gallery.component";
import { FlexLayoutModule } from "@angular/flex-layout";
import { GuardianListComponent } from "./guardian/guardian-list/guardian-list.component";
import { GuardianItemComponent } from "./guardian/guardian-item/guardian-item.component";
import { DialogFilterComponent } from "./widget/dialog-filter/dialog-filter.component";
import { VariedadSearchComponent } from "./variedad/variedad-search/variedad-search.component";
import { DatePickerComponent } from "./widget/date-picker/date-picker.component";

import { ObservationEditComponent } from "./observation/observation-edit/observation-edit.component";
import { ObservationAddComponent } from "./observation/observation-add/observation-add.component";
import { ObservationItemComponent } from "./observation/observation-item/observation-item.component";

import { TemplateAComponent } from "./widget/template-a/template-a.component";
import { TemplateMapComponent } from "./widget/template-map/template-map.component";
import { TemplateCardComponent } from "./widget/template-card/template-card.component";
import { SliderImageComponent } from "./widget/slider-image/slider-image.component";
import { TemplateRowComponent } from "./widget/template-row/template-row.component";
import { FormContactUsComponent } from "./widget/form-contact-us/form-contact-us.component";
import { MyErrorStateMatcherComponent } from "./widget/my-error-state-matcher/my-error-state-matcher.component";
import { NgcCookieConsentModule } from "ngx-cookieconsent";
import { ObservationConfigComponent } from "./observation/observation-config/observation-config.component";
import { DialogGalleryComponent } from "./widget/dialog-gallery/dialog-gallery.component";
import { UserViewComponent } from "./user/user-view/user-view.component";
import { UserEditComponent } from "./user/user-edit/user-edit.component";
import { TemplateRowViewObsComponent } from "./widget/template-row-view-obs/template-row-view-obs.component";
import { TemplateRowEditObsComponent } from "./widget/template-row-edit-obs/template-row-edit-obs.component";
import { ObservationListEditComponent } from "./observation/observation-list-edit/observation-list-edit.component";
import { ObservationListViewComponent } from "./observation/observation-list-view/observation-list-view.component";
import { VariedadListEditComponent } from "./variedad/variedad-list-edit/variedad-list-edit.component";
import { VariedadListViewComponent } from "./variedad/variedad-list-view/variedad-list-view.component";
import { TemplateRowViewVarComponent } from "./widget/template-row-view-var/template-row-view-var.component";
import { TemplateRowEditVarComponent } from "./widget/template-row-edit-var/template-row-edit-var.component";
import { LeafletModule } from "@asymmetrik/ngx-leaflet";
import { LeafletMarkerClusterModule } from "@asymmetrik/ngx-leaflet-markercluster";
import { VariedadImportComponent } from './variedad/variedad-import/variedad-import.component';
import { ObservationImportComponent } from './observation/observation-import/observation-import.component';
import { DialogDetailsComponent } from "./widget/dialog-details/dialog-details.component";
import { DialogFormVarietyComponent } from './widget/dialog-form-variety/dialog-form-variety.component';
import { QRCodeModule } from "angularx-qrcode";
import { TemplateMultimediaComponent } from './widget/template-multimedia/template-multimedia.component';
import { TemplateMapAdvanceComponent } from './widget/template-map-advance/template-map-advance.component';
import { VariedadListQrComponent } from './variedad/variedad-list-qr/variedad-list-qr.component';

@NgModule({
  imports: [
    CommonModule,
    DemoMaterialModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FlexLayoutModule,
    LeafletModule,
    NgcCookieConsentModule,
    LeafletMarkerClusterModule,
    QRCodeModule
  ],
  declarations: [
    DetailViewComponent,
    GalleryComponent,
    GalleryZoom,
    VariedadEditComponent,
    EspecieListComponent,
    EspecieEditComponent,
    DescriptorListComponent,
    DescriptorEditComponent,
    DescriptorDataListComponent,
    DescriptorDataEditComponent,
    DescriptorCategoriaListComponent,
    DescriptorCategoriaEditComponent,
    VariedadItemComponent,
    DescriptorItemComponent,
    DescriptorCategoriaItemComponent,
    DescriptorDataItemComponent,
    EspecieItemComponent,
    InfoItemComponent,
    AuthSigInComponent,
    AuthSigUpComponent,
    GuardianListComponent,
    GuardianItemComponent,
    DialogFilterComponent,
    VariedadSearchComponent,
    DatePickerComponent,
    ObservationEditComponent,
    ObservationAddComponent,
    ObservationItemComponent,
    TemplateAComponent,
    TemplateMapComponent,
    TemplateCardComponent,
    SliderImageComponent,
    TemplateRowComponent,
    FormContactUsComponent,
    MyErrorStateMatcherComponent,
    ObservationConfigComponent,
    DialogGalleryComponent,
    UserEditComponent,
    TemplateRowViewObsComponent,
    TemplateRowEditObsComponent,
    ObservationListEditComponent,
    ObservationListViewComponent,
    VariedadListEditComponent,
    VariedadListViewComponent,
    TemplateRowViewVarComponent,
    TemplateRowEditVarComponent,
    VariedadImportComponent,
    ObservationImportComponent,
    DialogDetailsComponent,
    DialogFormVarietyComponent,
    UserViewComponent,
    TemplateMultimediaComponent,
    TemplateMapAdvanceComponent,
    VariedadListQrComponent
  ],
  exports: [
    DemoMaterialModule,
    RouterModule,
    FlexLayoutModule,
    DetailViewComponent,
    GalleryComponent,
    GalleryZoom,
    VariedadEditComponent,
    EspecieListComponent,
    EspecieEditComponent,
    DescriptorListComponent,
    DescriptorEditComponent,
    DescriptorDataListComponent,
    DescriptorDataEditComponent,
    DescriptorCategoriaListComponent,
    DescriptorCategoriaEditComponent,
    VariedadItemComponent,
    DescriptorItemComponent,
    DescriptorCategoriaItemComponent,
    DescriptorDataItemComponent,
    EspecieItemComponent,
    InfoItemComponent,
    AuthSigInComponent,
    AuthSigUpComponent,
    GuardianListComponent,
    GuardianItemComponent,
    DialogFilterComponent,
    VariedadSearchComponent,
    DatePickerComponent,
    ObservationEditComponent,
    ObservationAddComponent,
    ObservationItemComponent,
    TemplateAComponent,
    TemplateMapComponent,
    TemplateCardComponent, SliderImageComponent,
    TemplateRowComponent,
    MyErrorStateMatcherComponent,
    FormContactUsComponent,
    ObservationConfigComponent,
    DialogGalleryComponent,
    UserEditComponent,
    TemplateRowViewObsComponent,
    TemplateRowEditObsComponent,
    ObservationListEditComponent,
    ObservationListViewComponent,
    VariedadListEditComponent,
    VariedadListViewComponent,
    TemplateRowViewVarComponent,
    TemplateRowEditVarComponent,
    VariedadImportComponent,
    ObservationImportComponent,
    DialogDetailsComponent,
    DialogFormVarietyComponent,
    UserViewComponent,
    TemplateMultimediaComponent,
    TemplateMapAdvanceComponent,
    VariedadListQrComponent,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
})
export class GizLibraryModule { }
